import { render, staticRenderFns } from "./TopicAdd.vue?vue&type=template&id=c2a52eca&"
import script from "./TopicAdd.vue?vue&type=script&lang=js&"
export * from "./TopicAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports